import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { ROUTE_SETTINGS_BENCHMARKS } from 'routes/RouteList';
import Icon from 'components/icon/Icon';
import ConfirmMutationButton from './ConfirmMutationButton';
import messages from 'messages';
import {
  MUTATION_ARCHIVE_BENCHMARK,
  QUERY_GET_BENCHMARKS
} from 'services/aws/benchmark-query';

const RemoveBenchmarkButton = ({
  benchmarkId,
  authStore,
  children,
  entityId,
  ...props
}) => {
  const { push } = useHistory();
  return (
    <ConfirmMutationButton
      {...props}
      mutation={MUTATION_ARCHIVE_BENCHMARK}
      variables={{ benchmarkId }}
      confirmTitle={messages.modalConfirmRemoveBenchmarkTitle}
      confirmMessage={messages.modalConfirmRemoveBenchmarkMessage}
      refetchQueries={[
        {
          query: QUERY_GET_BENCHMARKS,
          variables: { entityId }
        }
      ]}
      update={(cache, { data: { archiveBenchmark } }) => {
        if (archiveBenchmark) {
          push(generatePath(ROUTE_SETTINGS_BENCHMARKS, { entityId }));
        }
      }}
    >
      <Icon id="delete" />
      {children}
    </ConfirmMutationButton>
  );
};

export default RemoveBenchmarkButton;
